const homeFallbackOrder = [
  'paver-driveways-hardscapes',
  'indoor-outdoor-tile-installation',
  'brick-block-masonry',
  'concrete-driveways-patios',
  'stone-veneer',
  'retaining-walls-drainage',
];

const footerFallbackOrder = [
  'paver-driveways-hardscapes',
  'brick-block-masonry',
  'indoor-outdoor-tile-installation',
  'concrete-driveways-patios',
  'brick-repair-repointing',
];

function selectServices(services, flag, fallbackOrder, limit) {
  const explicitlySelected = services.filter((service) => service[flag] === true);
  if (explicitlySelected.length) return explicitlySelected.slice(0, limit);

  const available = services.filter((service) => service[flag] !== false);
  const bySlug = new Map(available.map((service) => [service.slug, service]));
  const prioritized = fallbackOrder.map((slug) => bySlug.get(slug)).filter(Boolean);
  const selectedSlugs = new Set(prioritized.map((service) => service.slug));
  const remainder = available.filter((service) => !selectedSlugs.has(service.slug));

  return [...prioritized, ...remainder].slice(0, limit);
}

export function getFeaturedServices(services, limit = 6) {
  return selectServices(services, 'featured', homeFallbackOrder, limit);
}

export function getFooterServices(services, limit = 6) {
  return selectServices(services, 'footer', footerFallbackOrder, limit);
}

export function getPrimaryServices(services) {
  return services.filter(
    (service) => service.primary !== false && service.slug !== 'chimney-masonry-repair',
  );
}

export function getNavigationServices(services) {
  return getPrimaryServices(services).filter((service) => service.navigation !== false);
}
